import Interceptors from './../Interceptors/Interceptors';
import { uploadImageFromFormData } from '../../Helpers/uploadViaPresign';

class Utils {
    constructor() {
        this.interceptors = new Interceptors();
    }

    async getFeaturedProduct(id, moduleName) {
        return this.interceptors.GET(`featured-product/${moduleName}/${id}/${false}`);
    }

    async uploadImage(data) {
        // data is FormData with an "image" field (legacy multipart shape).
        // Routed through api-v2 presign + direct-to-S3 PUT; response shape
        // matches the legacy multipart envelope so consumers don't change.
        return uploadImageFromFormData(data);
    }

    async updateStatus(postData) {
        return this.interceptors.PUT("utils/update-status/", postData);
    }
}

export default Utils;